<div class="tab-pane" role="tabpanel" id="propietario">
    <fieldset id="agregar_propietario" class="">
        <div class="step_section">
            <h4 class="form-signin-heading"><strong>Informaci&oacute;n de los Propietarios(<span
                        style="color:red; font-size: 25px">*</span>)</strong></h4>
            <hr>
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar propietario</p>
                    <div class="form-horizontal">
                        <div class="form-group">

                            
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <form [formGroup]="rut_pro">
                                        <mat-form-field class="example-full-width" style="width: 100%">
                                            <input matInput placeholder="Rut" id="rut_pro" name="rut_pro" formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                            <mat-error *ngIf="rut_pro && rut_pro.controls?.rut.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                            <mat-error *ngIf="rut_pro && rut_pro.controls?.rut.hasError('invalidRut')">
                                                Este rut es <strong>invalido</strong>
                                            </mat-error>

                                        </mat-form-field>
                                    </form>

                                    <!-- <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="Rut" #rut_proText="ngModel" [(ngModel)]="rut_pro" (ngModelChange)="validateRut($event)" id="rut_pro" name="rut_pro" >
                                            
                                        </mat-form-field> -->
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4 text-center">
                                    <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_pro"
                                        [disabled]="!rut_pro.valid" (click)="get_propietario(rut_pro.controls.rut.value)">
                                        Agregar Propietario
                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                    </button>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4"></div>
                            

                        </div>
                    </div>

                    <!--Detalle de los propietarios-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                            [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut | rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span><span> {{row.apellido_pat}}</span><span>
                                        {{row.apellido_mat}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_propietario(row.rut, rowIndex)" style="padding-right: 5px;"><i
                                            class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_propietario(rowIndex)"><i
                                            class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>

    <!--Material Modal Dialog-->
    <!-- <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del Propietario</h2>
        <mat-dialog-content class="text-center">
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <p><i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del Propietario</strong>, su solicitud pasar&aacute; <br>por un
                    proceso de verificaci&oacute;n del Propietario ingresado. </p>
                    <p><i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong></p>
                </div>
                
                <div class="form-group">
                    
                    <label class="col-md-4 control-label" for="rut">RUT (<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md"
                            [(ngModel)]="propietario.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="nombre_propiet">Nombre (<span
                            style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="nombre_propiet" name="nombre_propiet" type="text"
                            placeholder="Nombre o Raz&oacute;n Social" [(ngModel)]="propietario.nombre"
                            class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <!-- <div id="hide-prop-enterprise"> -->
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="apelpat_propiet">Apellido Paterno</label>
                    <div class="col-md-6">
                        <input id="apelpat_propiet" name="apelpat_propiet" type="text" placeholder="Apellido Paterno"
                            [(ngModel)]="propietario.apellido_pat" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="apelmat_propiet">Apellido Materno</label>
                    <div class="col-md-6">
                        <input id="apelmat_propiet" name="apelmat_propiet" type="text" placeholder="Apellido Materno"
                            [(ngModel)]="propietario.apellido_mat" class="form-control input-md">
                        <input id="nombre_completo" name="nombre_completo" type="hidden" placeholder="nombre_completo"
                            [(ngModel)]="propietario.nombre_completo">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <!-- </div> -->
                <!-- <div hidden="hidden"> -->
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_calle_propiet">Calle (<span
                            style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="direccion" name="direccion" type="text" placeholder="Calle"
                            [(ngModel)]="propietario.direccion" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_num_propiet">Numero(<span
                            style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="dir_num_propiet" name="dir_num_propiet" type="text" placeholder="Numero"
                            [(ngModel)]="propietario.direccion_num" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="direccion_complemento">Complemento</label>
                    <div class="col-md-6">
                        <input id="direccion_complemento" name="direccion_complemento" type="text"
                            placeholder="Complemento" [(ngModel)]="propietario.direccion_complemento"
                            class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="comuna">Comuna(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <mat-form-field class="example-full-width">
                            <input type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput
                                [formControl]="nombreComuna" [matAutocomplete]="auto" [(ngModel)]="propietario.comuna">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field> -->
                        <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                    <!-- </div>
                    <div class="col-md-2"></div>
                </div> -->
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_completa_propiet">Direcci&oacute;n: Completa</label>
                    <div class="col-md-6">
                        <input id="dir_completa_propiet" name="dir_completa_propiet" type="text" placeholder="Completa" [(ngModel)]="propietario.direccion_completa" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <!-- </div> -->
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="fono_propiet">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono" name="fono" type="text" placeholder="Tel&eacute;fono"
                            [(ngModel)]="propietario.fono" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fax">Fax</label>
                    <div class="col-md-6">
                        <input id="fax" name="fax" type="text" placeholder="Fax" [(ngModel)]="propietario.fax"
                            class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <!-- <form [formGroup]="mail_pro">
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="email_propiet">Email (<span
                                style="color: red">*</span>)</label>
                        <div class="col-md-6">
                            <mat-form-field  style="width: 100%;"  floatLabel="never" >
                                <input matInput type="email" placeholder="Email" id="email_propiet"
                                    name="email_propiet" formControlName="mail" [(ngModel)]="propietario.mail"
                                    class="form-control input-md">
                                <mat-error *ngIf="mail_pro.controls.mail.errors?.required">Email requerido
                                </mat-error>
                                <mat-error *ngIf="mail_pro.controls.mail.errors?.pattern">Formato incorrecto.
                                    Ej:
                                    correo@servidor.dominio. </mat-error>
                                <mat-error *ngIf="mail_pro.controls.mail.errors?.maxlength">Excede el máximo de
                                    caracteres
                                    (50). </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </form> -->
                <!--   <div class="form-group">
                    <label class="col-md-4 control-label" for="email_propiet">Email (<span
                            style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="email_propiet" name="email_propiet" type="email" placeholder="mail@ejemplo.com"
                            [(ngModel)]="propietario.mail" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
            <!-- </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
                (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_propiet" (click)="savePropietario() "
                [disabled]="!propietario.rut || !propietario.nombre || !propietario.direccion || !propietario.direccion_num || !propietario.comuna || !propietario.mail || mail_pro.status == 'INVALID'">Ingresar
                Propietario <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template> -->
    <!--End Material Dialog-->

    <!--Material Modal NUEVO Dialog-->
    <ng-template #openModal>
        
        <mat-dialog-content class="text-center">
            <h2 mat-dialog-title>Ingresar informaci&oacute;n del Propietario</h2>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <p><i class="fa fa-info-circle" aria-hidden="true"></i>
                        <strong> Debe ingresar la informacion del Propietario</strong>, su solicitud pasar&aacute; <br>por
                        un
                        proceso de verificaci&oacute;n del Propietario ingresado. </p>
                    <p><i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                        <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong></p>
                </div>
    
                <div class="form-group">
                    <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width" style="width: 100%">
                                <input matInput id="rut" name="rut" type="text"  class=""
                                    [(ngModel)]="propietario.rut" placeholder="Rut (*)" readonly>
                            </mat-form-field>
                        </div>
                    <div class="col-md-2"></div>
                </div>


                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                             <input matInput id="nombre_propiet" name="nombre_propiet" type="text"
                                    placeholder="Nombre o Raz&oacute;n Social (*)" [(ngModel)]="propietario.nombre"
                                    class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>


                <!-- <div id="hide-prop-enterprise"> -->
                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="apelpat_propiet" name="apelpat_propiet" type="text" placeholder="Apellido Paterno"
                            [(ngModel)]="propietario.apellido_pat" class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="apelmat_propiet" name="apelmat_propiet" type="text" placeholder="Apellido Materno"
                                [(ngModel)]="propietario.apellido_mat" class="">
                            <input  id="nombre_completo" name="nombre_completo" type="hidden" placeholder="nombre_completo"
                                [(ngModel)]="propietario.nombre_completo">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- </div> -->
                <!-- <div hidden="hidden"> -->
                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="direccion" name="direccion" type="text" placeholder="Calle (*)"
                                [(ngModel)]="propietario.direccion" class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="dir_num_propiet" name="dir_num_propiet" type="text" placeholder="Numero (*)"
                                [(ngModel)]="propietario.direccion_num" class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="direccion_complemento" name="direccion_complemento" type="text" placeholder="Complemento"
                                [(ngModel)]="propietario.direccion_complemento" class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput
                                [formControl]="nombreComuna" [matAutocomplete]="auto" [(ngModel)]="propietario.comuna" placeholder="Comuna">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- <div class="form-group">
                        <label class="col-md-4 control-label" for="dir_completa_propiet">Direcci&oacute;n: Completa</label>
                        <div class="col-md-6">
                            <input id="dir_completa_propiet" name="dir_completa_propiet" type="text" placeholder="Completa" [(ngModel)]="propietario.direccion_completa" class="form-control input-md">
                        </div>
                        <div class="col-md-2"></div>
                    </div> -->
                <!-- </div> -->
                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="fono" name="fono" type="text" placeholder="Tel&eacute;fono"
                                [(ngModel)]="propietario.fono" class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="fax" name="fax" type="text" placeholder="Fax" [(ngModel)]="propietario.fax"
                                class="">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <form [formGroup]="mail_pro">
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field style="width: 100%;" floatLabel="never">
                                <input matInput type="email" placeholder="Email (*)" id="email_propiet" name="email_propiet"
                                    formControlName="mail" [(ngModel)]="propietario.mail" class="">
                                <mat-error *ngIf="mail_pro.controls.mail.errors?.required">Email requerido
                                </mat-error>
                                <mat-error *ngIf="mail_pro.controls.mail.errors?.pattern">Formato incorrecto.
                                    Ej:
                                    correo@servidor.dominio. </mat-error>
                                <mat-error *ngIf="mail_pro.controls.mail.errors?.maxlength">Excede el máximo de
                                    caracteres
                                    (50). </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </form>
                <!--   <div class="form-group">
                        <label class="col-md-4 control-label" for="email_propiet">Email (<span
                                style="color: red">*</span>)</label>
                        <div class="col-md-6">
                            <input id="email_propiet" name="email_propiet" type="email" placeholder="mail@ejemplo.com"
                                [(ngModel)]="propietario.mail" class="form-control input-md">
                        </div>
                        <div class="col-md-2"></div>
                    </div> -->
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
                (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_propiet" (click)="savePropietario() "
                [disabled]="!propietario.rut || !propietario.nombre || !propietario.direccion || !propietario.direccion_num || !propietario.comuna || !propietario.mail || mail_pro.status == 'INVALID'">Ingresar
                Propietario <i class="fa fa-user-o " aria-hidden="true "></i></button>
    
        </mat-dialog-actions>
    </ng-template>
    <!--End Material NUEVO Dialog-->


    <!--Material Modal Dialog 2-->
    <ng-template #openModalVer>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del Propietario</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del Propietario</strong>, su solicitud pasar&aacute; por un
                    proceso de verificaci&oacute;n del Propietario ingresado.
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rut">RUT</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md"
                            [(ngModel)]="propietario.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="nombre_propiet">Nombre</label>
                    <div class="col-md-6">
                        <input id="nombre_propiet" name="nombre_propiet" type="text"
                            placeholder="Nombre o Raz&oacute;n Social" [(ngModel)]="propietario.nombre"
                            class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- <div id="hide-prop-enterprise"> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="apelpat_propiet">Apellido Paterno</label>
                    <div class="col-md-6">
                        <input id="apelpat_propiet" name="apelpat_propiet" type="text" placeholder="Apellido Paterno"
                            [(ngModel)]="propietario.apellido_pat" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="apelmat_propiet">Apellido Materno</label>
                    <div class="col-md-6">
                        <input id="apelmat_propiet" name="apelmat_propiet" type="text" placeholder="Apellido Materno"
                            [(ngModel)]="propietario.apellido_mat" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- </div> -->
                <!-- <div hidden="hidden"> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_calle_propiet">Direcci&oacute;n Calle</label>
                    <div class="col-md-6">
                        <input id="direccion" name="direccion" type="text" placeholder="Calle"
                            [(ngModel)]="propietario.direccion" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_num_propiet">Direcci&oacute;n Numero</label>
                    <div class="col-md-6">
                        <input id="dir_num_propiet" name="dir_num_propiet" type="text" placeholder="Numero"
                            [(ngModel)]="propietario.direccion_num" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="direccion_complemento">Direcci&oacute;n
                        Complemento</label>
                    <div class="col-md-6">
                        <input id="direccion_complemento" name="direccion_complemento" type="text"
                            placeholder="Complemento" [(ngModel)]="propietario.direccion_complemento"
                            class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="comuna">Comuna</label>
                    <div class="col-md-6">
                        <input id="comuna" name="comuna" type="text" placeholder="Comuna"
                            [(ngModel)]="propietario.comuna" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="dir_completa_propiet">Direcci&oacute;n Completa</label>
                    <div class="col-md-6">
                        <input id="dir_completa_propiet" name="dir_completa_propiet" type="text" placeholder="Completa"
                            [(ngModel)]="propietario.direccion_completa" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- </div> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fono_propiet">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono" name="fono" type="text" placeholder="Tel&eacute;fono"
                            [(ngModel)]="propietario.fono" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fax">Fax</label>
                    <div class="col-md-6">
                        <input id="fax" name="fax" type="text" placeholder="Fax" [(ngModel)]="propietario.fax"
                            class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="email_propiet">Email</label>
                    <div class="col-md-6">
                        <input id="email_propiet" name="email_propiet" type="text" placeholder="mail@ejemplo.com"
                            formControlName="email" [email][(ngModel)]="propietario.mail" class="form-control input-md"
                            readonly>
                        <!--<input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />-->

                        <!--<span *ngIf="f.submitted && f.controls['email'].errors"
                        class="text-danger animated fadeIn">El correo es obligatorio</span> -->
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
                (click)="cleanData()">Salir</button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog 2-->
</div>